var map = {
	"./Admin.png": "26ec",
	"./Assessment.png": "c890",
	"./Attendance.png": "d887",
	"./Books.png": "8a16",
	"./Circle.png": "1d8a",
	"./Delete.png": "346f",
	"./Edit.png": "5363",
	"./Home.png": "38da",
	"./Live_class.png": "71ad",
	"./Messages.png": "261f",
	"./Notice.png": "f114",
	"./Notification.png": "448d",
	"./Profile.png": "4383",
	"./Report-card.png": "e2d2",
	"./Social.png": "e99e",
	"./Store.png": "455a",
	"./Stores.png": "cbe0",
	"./Syllabus.png": "16cb",
	"./admin.svg": "2539",
	"./alerts.svg": "8e62",
	"./ask.svg": "ab2e",
	"./attendance.svg": "84d7",
	"./bus-school.png": "8485",
	"./bus.svg": "6769",
	"./bus_location_pin.svg": "a1e0",
	"./download.png": "2a5c",
	"./downloads.svg": "d868",
	"./events.svg": "c9f8",
	"./exams.svg": "c202",
	"./fee.svg": "fa62",
	"./feedback.svg": "e045",
	"./fees.png": "30f3",
	"./fees.svg": "01c6",
	"./gallery.svg": "9da7",
	"./holidays.svg": "b449",
	"./homework.svg": "8755",
	"./live.svg": "44d5",
	"./magazine.svg": "d56f",
	"./notice.svg": "b6dd",
	"./quiz.png": "f7c9",
	"./tests.svg": "dc1f",
	"./timetable.svg": "2a78",
	"./upload.png": "1a15",
	"./video_conference.svg": "941f",
	"./website.svg": "f71d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2de2";